import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Key = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M12.65 10.4512C11.83 8.12117 9.61 6.45117 7 6.45117C3.69 6.45117 1 9.14117 1 12.4512C1 15.7612 3.69 18.4512 7 18.4512C9.61 18.4512 11.83 16.7812 12.65 14.4512H17V18.4512H21V14.4512H23V10.4512H12.65ZM7 14.4512C5.9 14.4512 5 13.5512 5 12.4512C5 11.3512 5.9 10.4512 7 10.4512C8.1 10.4512 9 11.3512 9 12.4512C9 13.5512 8.1 14.4512 7 14.4512Z"
    />
  </svg>
);
